import { string } from 'yup';

import { RegexUtils } from '../regex-utils';

export const loginValidations = {
  userNameLogin: string()
    .required('Please enter your username')
    .matches(RegexUtils.userNameUTF8Regex, 'Please enter valid username')
    .max(120, 'Character length exceeded')
    .trim(),

  passwordLogin: string().required('Please enter a password'),

  userNameOrEmail: string()
    .required('Username is required')
    .test('email-or-username', 'Must be a valid username', function (value) {
      const usernameRegex = /^[a-zA-Z0-9._-]{3,}$/;
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return usernameRegex.test(value) || emailRegex.test(value);
    }),
};
